export default __webpack_public_path__ + "static/media/start.1b86dd86.svg";